import { render, staticRenderFns } from "./CoreAdmin.vue?vue&type=template&id=14684665&scoped=true&"
import script from "./CoreAdmin.vue?vue&type=script&lang=js&"
export * from "./CoreAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CoreAdmin.vue?vue&type=style&index=0&id=14684665&scoped=true&lang=css&"
import style1 from "./CoreAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14684665",
  null
  
)

component.options.__file = "CoreAdmin.vue"
export default component.exports